<div class="fb-order-list-item text-xs sm:text-sm ">
	<div class="fb-order-status flex justify-between items-center w-full bg-[#fffcf7]/80 shadow px-4 py-2 rounded-t-lg">
		<p class="font-semibold flex flex-wrap items-center gap-1">
			<span *ngIf="item.orderType === 'CUSTOM_ORDER'" class="flex items-center gap-0.5 text-xs CUSTOM">
				<span class="material-symbols-outlined">
					quick_reorder
				</span>
				Custom Order
			</span>
			<span *ngIf="item.orderType === 'ORDER'" class="text-xs">Order</span> #{{item.orderId}}
		</p>
		<p [ngClass]="item.status"
		   *ngIf="(item.status==='IN_TRANSIT' && item.dispatchedOn)">Partially Dispatched</p>
		<p [ngClass]="item.status"
		   *ngIf="item.status==='CANCELLED'">Cancelled</p>
		<p [ngClass]="item.status"
		   *ngIf="item.status==='INITIATED'">Initiated</p>
		<p [ngClass]="item.status"
		   *ngIf="item.status==='PROCESSING'">Processing</p>
		<p [ngClass]="item.status"
		   *ngIf="item.status==='DELIVERED'">Delivered</p>
		<p [ngClass]="item.status"
		   *ngIf="item.status==='FAILED'">Failed</p>
		<p *ngIf="item.status ==='DISPATCHED' && item.dispatchedOn" class="dispatch_on">Dispatched On {{item.dispatchedOn | formatDate}}</p>
	</div>
	<div class="flex justify-between items-center px-4 py-2 gap-2 mb-2">
		<div class="flex flex-col justify-center items-center gap-1.5">
			<img class="max-h-[140px] object-contain px-2 pt-3" src="./assets/img/order-package.png" alt="item" />
			<p>{{item.totalItemCount}} Item{{item.totalItemCount>1?'s':''}}</p>
		</div>
		<div class="flex flex-col gap-2">
			<p>Order Placed On: {{item.createdAt | formatDate}}</p>
			<div class="flex justify-start items-center gap-2 mb-2 mt-1.5">
				<a *ngIf="item.trackingUrl"
				   class="rounded-md bg-[#B7A990]/80 px-3 py-1.5"
				   href="{{item.trackingUrl}}"
				   target="_blank" rel="nofollow">
					<button>Track Order</button>
				</a>
				<a class="rounded-md bg-[#fffcf7] border-[1px] border-[#B7A990] px-3 py-1.5"
				   routerLink="/profile/{{url}}/{{item.orderId}}" target="_blank">
					<button>View Order</button>
				</a>
				<a *ngIf="item.orderType === 'ORDER' && !item.dispatchedOn && !(item.status==='CANCELLED')"
				   [ngClass]="((today - item.createdAt) > msIn24Hours)? 'fb-cancel-disabled': ''"
				   class="rounded-md bg-white shadow px-3 py-1.5">
					<button [disabled]="((today - item.createdAt) > msIn24Hours)"
							(click)="cancelOrder(item.orderId)">Cancel Order</button>
				</a>

			</div>
			<div class="est_delivery">
				Estimated Delivery On: <span class="font-semibold">{{item.estimatedDeliveryDate | formatDate}}</span>
			</div>
			<div *ngIf="item.orderType === 'ORDER' && !item.dispatchedOn && ((today - item.createdAt) > msIn24Hours) && !(item.status==='CANCELLED')"
				 class="text-xs text-red-500 text-left w-full">Cancellation is disabled after 24 hours</div>
		</div>
	</div>
	<a *ngIf="item.status !== 'CANCELLED'"
	   routerLink="/profile/{{url}}/{{item.orderId}}"
		 class="shadow rounded-md m-2 p-2 grid grid-cols-4 gap-2">
		<div class="bg-white cursor-pointer rounded-md flex flex-col justify-center items-center">
			<div class="rounded-full p-1 flex justify-center items-center">
				<span class="text-[#52a183] material-symbols-outlined">check_circle</span>
			</div>
			<div class="flex flex-col gap-1 justify-center items-center">
				<p class="text-[#52a183] text-xs md:text-sm flex gap-2 items-center">
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#52a183" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-box"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>
					Confirmed
				</p>
			</div>
		</div>

		<div class="bg-white cursor-pointer rounded-md flex flex-col justify-center items-center">
			<div *ngIf="item.processingItemCount && item.processingItemCount !== item.totalItemCount"
				 class="text-[#BB955E] rounded-full p-1 flex justify-center items-center pb-1">
				{{getPercentage(item.processingItemCount, item.totalItemCount)}}%
			</div>
			<div *ngIf="item.processingItemCount && item.processingItemCount === item.totalItemCount"
				 class="rounded-full p-1 flex justify-center items-center">
				<span class="text-[#52a183] material-symbols-outlined">check_circle</span>
			</div>
			<svg *ngIf="!item.processingItemCount" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#dbdbdb"><path d="M320-160h320v-120q0-66-47-113t-113-47q-66 0-113 47t-47 113v120Zm160-360q66 0 113-47t47-113v-120H320v120q0 66 47 113t113 47ZM160-80v-80h80v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-80v-80h640v80h-80v120q0 61-28.5 114.5T612-480q51 32 79.5 85.5T720-280v120h80v80H160Z"/></svg>
			<div class="flex flex-col gap-1 justify-center items-center">
				<p class="text-xs md:text-sm flex gap-2 items-center"
				   [ngClass]="item.processingItemCount !== item.totalItemCount? !item.processingItemCount? 'step-not-started':'step-in-progress':'step-complete'">
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-package-plus"><path d="M16 16h6"/><path d="M19 13v6"/><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"/><path d="m7.5 4.27 9 5.15"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" x2="12" y1="22" y2="12"/></svg>
					Processing
				</p>
			</div>
		</div>

		<div class="bg-white cursor-pointer rounded-md flex flex-col justify-center items-center">
			<div *ngIf="item.readyItemCount && item.readyItemCount !== item.totalItemCount"
				 class="text-[#5950B7] rounded-full p-1 flex justify-center items-center pb-1">
				{{getPercentage(item.readyItemCount, item.totalItemCount)}}%
			</div>
			<div *ngIf="item.readyItemCount && item.readyItemCount === item.totalItemCount"
				 class="rounded-full p-1 flex justify-center items-center">
				<span class="text-[#52a183] material-symbols-outlined">check_circle</span>
			</div>
			<svg *ngIf="!item.readyItemCount" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#dbdbdb"><path d="M320-160h320v-120q0-66-47-113t-113-47q-66 0-113 47t-47 113v120Zm160-360q66 0 113-47t47-113v-120H320v120q0 66 47 113t113 47ZM160-80v-80h80v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-80v-80h640v80h-80v120q0 61-28.5 114.5T612-480q51 32 79.5 85.5T720-280v120h80v80H160Z"/></svg>
			<div class="flex flex-col gap-1 justify-center items-center">
				<p class="text-xs md:text-sm flex gap-2 items-center"
				   [ngClass]="item.readyItemCount !== item.totalItemCount? !item.readyItemCount? 'step-not-started':'step-ready':'step-complete'">

					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-package-check"><path d="m16 16 2 2 4-4"/><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"/><path d="m7.5 4.27 9 5.15"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" x2="12" y1="22" y2="12"/></svg>
					Ready
				</p>
			</div>
		</div>

		<div class="bg-white cursor-pointer rounded-md flex flex-col justify-center items-center">
			<div class="rounded-full p-1 flex justify-center items-center text-gray-500">
				<svg *ngIf="!item.dispatchedItemCount" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#dbdbdb"><path d="M320-160h320v-120q0-66-47-113t-113-47q-66 0-113 47t-47 113v120Zm160-360q66 0 113-47t47-113v-120H320v120q0 66 47 113t113 47ZM160-80v-80h80v-120q0-61 28.5-114.5T348-480q-51-32-79.5-85.5T240-680v-120h-80v-80h640v80h-80v120q0 61-28.5 114.5T612-480q51 32 79.5 85.5T720-280v120h80v80H160Z"/></svg>
				<div *ngIf="item.dispatchedItemCount && item.dispatchedItemCount !== item.totalItemCount"
					 class="step-in-progress rounded-full p-1 flex justify-center items-center pb-1">
					{{getPercentage(item.dispatchedItemCount, item.totalItemCount)}}%
				</div>
				<div *ngIf="item.dispatchedItemCount && item.dispatchedItemCount === item.totalItemCount"
					 class="rounded-full p-1 flex justify-center items-center">
					<span class="text-[#52a183] material-symbols-outlined">check_circle</span>
				</div>
			</div>
			<div class="flex flex-col gap-1 justify-center items-center">
				<p class="text-xs md:text-sm flex gap-2 items-center"
				   [ngClass]="item.dispatchedItemCount !== item.totalItemCount? !item.dispatchedItemCount? 'step-not-started':'step-in-progress':'step-complete'">

					<svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="undefined" stroke="#EBEAE9"><path d="M280-160q-50 0-85-35t-35-85H60l18-80h113q17-19 40-29.5t49-10.5q26 0 49 10.5t40 29.5h167l84-360H182l4-17q6-28 27.5-45.5T264-800h456l-37 160h117l120 160-40 200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H400q0 50-35 85t-85 35Zm357-280h193l4-21-74-99h-95l-28 120Zm-19-273 2-7-84 360 2-7 34-146 46-200ZM20-427l20-80h220l-20 80H20Zm80-146 20-80h260l-20 80H100Zm180 333q17 0 28.5-11.5T320-280q0-17-11.5-28.5T280-320q-17 0-28.5 11.5T240-280q0 17 11.5 28.5T280-240Zm400 0q17 0 28.5-11.5T720-280q0-17-11.5-28.5T680-320q-17 0-28.5 11.5T640-280q0 17 11.5 28.5T680-240Z"/></svg>
					Dispatched
				</p>
			</div>
		</div>
	</a>
	<div *ngIf="item.status === 'CANCELLED'" class="shadow rounded-md m-2 p-2 text-center text-gray-500">
		No updates available
	</div>
</div>
